module.exports = __webpack_public_path__ + "static/media/Ellipse 62.2c343156.svg";